import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API_BASE from "../config/api";
import Profile from "./Profile";

export default function MyListings() {
    const navigate = useNavigate();
    const [listings, setListings] = useState([]);
    const [loading, setLoading] = useState(true);

    const userData = JSON.parse(localStorage.getItem("user"));
    const user_id = userData?.personaluid;

    useEffect(() => {
        if (!user_id) {
            setLoading(false);
            return;
        }

        fetch(`${API_BASE}/api/get_user_listings.php`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ user_id }),
        })
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    setListings(data.listings);
                }
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [user_id]);

    const openListing = (listinguid) => navigate(`/profile?listinguid=${listinguid}`);
    const goToUpgrade = (listinguid) => {
        // Redirect to the Upgrade page with listinguid as query param
        navigate(`/upgradelisting?listinguid=${listinguid}`);
    };

    if (loading) {
        return <div className="text-center py-5 fs-4 fw-semibold text-secondary">Loading...</div>;
    }

    return (
        <div className="container py-4">
            <h2 className="fw-bold mb-4 text-primary">My Listed Businesses</h2>

            {listings.length === 0 ? (
                <div className="alert alert-info shadow-sm p-3 fs-5 text-center">
                    You have not listed any business yet.
                </div>
            ) : (
                <div className="row g-4">
                    {listings.map((item, index) => (
                        <div key={item.id} className="col-md-6 col-lg-4">
                            <div className="card border-0 shadow-lg rounded-4 listing-card h-100">
                                <div className="card-body">

                                    <span className="badge bg-primary mb-2 px-3 py-2">
                                        #{index + 1}
                                    </span>

                                    <h5 className="card-title fw-bold text-dark mb-2">
                                        {item.title}
                                    </h5>

                                    <p className="text-muted small mb-1">
                                        📍 {item.province}, {item.district}
                                    </p>

                                    <p className="text-muted small mb-1">
                                        📞 {item.mobile}
                                    </p>

                                    <p className="text-muted small mb-2">
                                        ✉️ {item.email}
                                    </p>

                                    <p className="text-secondary small">
                                        <strong>Created:</strong> {item.created_at}
                                    </p>

                                    {/* Action Buttons */}
                                    <div className="d-flex justify-content-between mt-3">

                                        <button
                                            className="btn btn-outline-primary btn-sm px-3"
                                            onClick={() => openListing(item.listinguid)}
                                        >
                                            View / Edit
                                        </button>

                                        <button className="btn btn-warning btn-sm px-3 fw-bold"
                                            onClick={() => goToUpgrade(item.listinguid)}>
                                            Upgrade ⭐
                                        </button>

                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {/* Custom Styles */}
            <style>
                {`
                .listing-card {
                    transition: all 0.3s ease;
                }
                .listing-card:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 10px 25px rgba(0,0,0,0.15);
                }
            `}
            </style>
        </div>
    );
}
